import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Values from "@/components/Values";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookieConsent from "@/components/CookieConsent";

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Values />
      <Contact />
    </main>
    <Footer />
  </>
);

const LegalLayout = ({ children }) => (
  <>
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/impressum"
              element={
                <LegalLayout>
                  <Impressum />
                </LegalLayout>
              }
            />
            <Route
              path="/datenschutz"
              element={
                <LegalLayout>
                  <Datenschutz />
                </LegalLayout>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors closeButton />
          <CookieConsent />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
